import {createSlice} from "@reduxjs/toolkit";
import {createFileTemplate} from "./actions/createFileTemplate";
import {updateFileTemplate} from "./actions/updateFileTemplate";
import {createTemplate} from "./actions/createTemplate";

interface TemplateCreateState {
  createStatus: string;
  createFileTemplateStatus: "idle" | "pending" | "succeeded" | "failed";
}

const initialState = {
  createStatus: "",
  createFileTemplateStatus: "idle",
} as TemplateCreateState;

const templateCreateSlice = createSlice({
  name: "templateCreate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createFileTemplate.pending, (state) => {
        state.createFileTemplateStatus = "pending";
      })
      .addCase(createFileTemplate.fulfilled, (state) => {
        state.createFileTemplateStatus = "succeeded";
      })
      .addCase(createFileTemplate.rejected, (state) => {
        state.createFileTemplateStatus = "failed";
      })
      .addCase(createTemplate.pending, (state, {payload}) => {
        state.createStatus = "pending";
      })
      .addCase(createTemplate.rejected, (state, {payload}) => {
        state.createStatus = "rejected";
      })
      .addCase(createTemplate.fulfilled, (state, {payload}) => {
        state.createStatus = "fulfilled";
      })


  },
});

export default templateCreateSlice.reducer;
